import { render, staticRenderFns } from "./trendzhishu.vue?vue&type=template&id=68149186"
import script from "./trendzhishu.vue?vue&type=script&lang=js"
export * from "./trendzhishu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports